// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Styling
import './pedido-suspensao.scss';

// Utils
import { SUSPENSION_TYPE_SUSPENSION_OPTION, getSuspensionReasonList, getSuspensionTypeList, isCloseSuspensionContactType, isSuspensionContactType } from '../../../common/lists/support';
import { isReasonOther } from '../../../common/lists/support';
import { PRODUCT_KEY_MESSAGE, PRODUCT_KEY_REASON, PRODUCT_KEY_SUSPENSION_DATE, PRODUCT_KEY_SUSPENSION_TYPE } from '../../../common/constants';

// Redux
import SuspensionService from '../../../redux/services/suspension';
import QuoteService from '../../../redux/services/quote';
import { updateBasket } from '../../../redux/actions/order';
import { connect } from 'react-redux';

class PedidoSuspensaoComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            suspensionDate: null,
            reason: null,
            suspensionType: null,
            reasonDetail: "",
            activeSuspension: false,
            quoteFee: null,
            validSuspensionDate: true,
            validReason: true,
            validSuspensionType: true,
            validReasonDetail: true,
            validSuspension: true,
            validQuotePayment: true
        }
    }

    componentDidMount() {
        SuspensionService.validateRegistrationSuspension(Number(this.props.ballot.ballotRef))
        .then((response) => { 
            this.setState({
                activeSuspension: response.activeSuspension
            });
        })
        .catch(error => { });

        QuoteService.getAssociateMissingQuotesFees(this.props.associate.associateId)
        .then((response) => { 
            this.setState({
                quoteFee: response.quoteFee
            });
        })
        .catch(error => { });
    }


    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        })
    }

    submitAcquisition() {
        if(this.validateForm()) {
            let metadata = [
                { key: PRODUCT_KEY_SUSPENSION_TYPE, value: this.state.suspensionType.code.toString() },
                { key: PRODUCT_KEY_SUSPENSION_DATE, value: this.state.suspensionDate.toISOString() },
                { key: PRODUCT_KEY_REASON, value: !isReasonOther(this.state.reason) ? this.state.reason.name : this.state.reasonDetail },
                { key: PRODUCT_KEY_MESSAGE, value: this.buildTicketMessage() },
            ];

            // Add product to basket
            let product = this.props.product;
            product.metadata = metadata;

            let products = [];

            for (let i = 0; i < this.props.basketProducts.length; i++) {
                products.push(this.props.basketProducts[i]);
                
            }

            products.push(product);

            this.props.updateBasket(products, this.props.basketTrainings);
            this.props.onClose();
        }
    }

    validateForm() {

        const validReasonDetail = !isReasonOther(this.state.reason) || (isReasonOther(this.state.reason) && this.state.reasonDetail !== "");

        this.setState({
            validSuspensionType: this.state.suspensionType !== null,
            validReason: this.state.reason !== null,
            validSuspensionDate: this.state.suspensionDate !== null,
            validReasonDetail: validReasonDetail,
            validSuspension: !this.state.activeSuspension,
            validQuotePayment: this.state.quoteFee === null || (this.state.quoteFee !== null && this.state.quoteFee.delayMonths === 0)
        });

        let validationResult = (this.state.suspensionType !== null && this.state.suspensionDate !== null) && this.state.reason !== null && validReasonDetail && !this.state.activeSuspension && (this.state.quoteFee === null || (this.state.quoteFee !== null && this.state.quoteFee.delayMonths === 0));

        return validationResult;
    }

    buildTicketMessage() {

        // Build full address
        var address = "";

        if(this.props.associate.personalData.streetTypePlaceholder !== null) {
            address += this.props.associate.personalData.streetTypePlaceholder;
        }

        if(this.props.associate.personalData.addressLine !== null) {
            address += " " + this.props.associate.personalData.addressLine;
        }

        if(this.props.associate.personalData.doorNumber !== null) {
            address += " " + this.props.associate.personalData.doorNumber;
        }

        if(this.props.associate.personalData.doorFloor !== null) {
            address += " " + this.props.associate.personalData.doorFloor;
        }

        var dd = String(this.state.suspensionDate.getDate()).padStart(2, '0');
        var mm = String(this.state.suspensionDate.getMonth() + 1).padStart(2, '0');
        var yyyy = this.state.suspensionDate.getFullYear();

        return this.props.t("support.form.suspension-message-part-1") + this.props.associate.personalData.name + this.props.t("support.form.suspension-message-part-2") + this.props.associate.personalData.identificationNumber + this.props.t("support.form.suspension-message-part-3") + this.props.associate.personalData.nif + this.props.t("support.form.suspension-message-part-4") + address + " " + this.props.associate.personalData.cP4 + "-" + this.props.associate.personalData.cP3 + " " + this.props.associate.personalData.city + this.props.t("support.form.suspension-message-part-5") + this.props.ballot.ballotRef + this.props.t("support.form.suspension-message-part-6") + (this.state.suspensionType.code === SUSPENSION_TYPE_SUSPENSION_OPTION.code ? this.props.t("support.form.suspension-message-part-7") : this.props.t("support.form.suspension-message-part-8")) + this.props.t("support.form.suspension-message-part-9") + (this.state.reason === null ? this.state.reasonDetail : this.state.reason.name) + this.props.t("support.form.suspension-message-part-10") + dd + '/' + mm + '/' + yyyy + this.props.t("support.form.suspension-message-part-11");
    }

    render() {
        return (
            <div className="grid mgt-10">
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.info-note")}</b>
                </div>
                <div className="col-12" style={{textAlign: "justify"}}>
                    <ul style={{marginLeft: "20px", padding: 0}}>
                    <li style={{marginBottom: "10px"}}>{this.props.t("products.labels.suspension-process")}</li>
                    <li style={{marginBottom: "10px"}}>{this.props.t("products.labels.suspension-pay-quotes")}</li>
                    <li>{this.props.t("products.labels.stop-suspension-price")}</li>
                    </ul>
                </div>
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.product-form")}</b>
                </div>
                <div className="col-12">
                    <div className="flex flex-column gap-2">
                        <label htmlFor="suspension-type">{this.props.t("products.labels.suspension-type")}</label>
                        <Dropdown id="suspension-type" className={!this.state.validSuspensionType ? "p-invalid" : null} value={this.state.suspensionType} onChange={(e) => this.updateFormComponent("suspensionType", e.value)} options={getSuspensionTypeList(getLanguage())} optionLabel="name" placeholder="Escolha um tipo de suspensão"></Dropdown>
                        { this.state.validSuspensionType ? null : <div className="invalid-message">{this.props.t("general.mandatory-field")}</div> }
                    </div>
                    <div className="flex flex-column gap-2 mgt-10">
                        <label htmlFor="reason">{this.props.t("products.labels.reason-title")}</label>
                        <Dropdown id="reason" className={!this.state.validReason ? "p-invalid" : null} value={this.state.reason} onChange={(e) => this.updateFormComponent("reason", e.value)} options={getSuspensionReasonList(getLanguage())} optionLabel="name" placeholder="Escolha um motivo"></Dropdown>
                        { this.state.validReason ? null : <div className="invalid-message">{this.props.t("general.mandatory-field")}</div> }
                    </div>
                    {
                        isReasonOther(this.state.reason) ? 
                            <div className="flex flex-column gap-2 mgt-10">
                                <label htmlFor="reasonDetail">{this.props.t("support.form.reason-detail")}</label>
                                <InputText value={this.state.reasonDetail} id="reasonDetail" type="text" onChange={(evt) => this.updateFormComponent("reasonDetail", evt.target.value)} />
                                { this.state.validReasonDetail ? null : <div className="invalid-message">{this.props.t("general.mandatory-field")}</div> }
                            </div>
                            : null
                    }
                    <div className="flex flex-column gap-2 mgt-10">
                        <label htmlFor="reason">{this.props.t("support.form.suspension-date")}</label>
                        <Calendar dateFormat="dd/mm/yy" minDate={new Date()} value={this.state.suspensionDate} showIcon showButtonBar onChange={(evt) => this.updateFormComponent("suspensionDate", evt.target.value)} />
                        { this.state.validSuspensionDate ? null : <div className="invalid-message">{this.props.t("general.mandatory-field")}</div> }
                        { this.state.validSuspension ? null : <small className="p-error">{this.props.t("support.messages.active-suspension")}</small>  }
                        { this.state.validQuotePayment ? null : <small className="p-error">{this.props.t("support.messages.quote-payment")}</small>  }
                    </div>
                </div>
                <div className='col-12 t-align-right'>
                    <div className="flex flex-wrap justify-content-end gap-2">
                        <Button label={this.props.t("products.labels.add")} icon="pi pi-shopping-cart" onClick={(evt) => this.submitAcquisition() }/>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(PedidoSuspensaoComponent));